import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-oppo-egypt-tournaments',
  templateUrl: './oppo-egypt-tournaments.component.html',
  styleUrls: ['./oppo-egypt-tournaments.component.scss']
})
export class OppoEgyptTournamentsComponent implements OnInit {
  tournaments = [];
  getScreenWidth
  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {

  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }
  changeRoute(param) {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('oppo-reno-cup-season-2', 1, 'pubg').subscribe(res => {
      this.tournaments = res.data.map(function(v){ return {name: v.name, value: v.code}});
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })

  }
  changeWidth(event){
    console.log(event)
    this.getScreenWidth = window.innerWidth;
    if(this.getScreenWidth == '1000'){
      console.log(this.getScreenWidth)
    }

  }
}
